import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Tabs,
  Tab,
  IconButton,
  useMediaQuery,
  useTheme
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const SummaryTabHeader = ({ activeTab, handleTabChange, onCopyClick }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        sx={{
          minHeight: 40,
          '& .MuiTab-root': {
            minHeight: 40,
            fontSize: isMobile ? '0.8rem' : '0.9rem',
            fontWeight: 500,
            textTransform: 'none',
            color: '#666',
            '&.Mui-selected': {
              color: '#1976d2',
              fontWeight: 600
            }
          },
          '& .MuiTabs-indicator': {
            backgroundColor: '#1976d2'
          }
        }}
      >
        <Tab label={t('analyze.summary')} />
        <Tab label={t('analyze.chapters')} />
      </Tabs>
      
      <IconButton
        onClick={onCopyClick}
        sx={{
          color: '#666',
          '&:hover': {
            color: '#1976d2',
            backgroundColor: 'rgba(25, 118, 210, 0.04)'
          }
        }}
        size="small"
      >
        <ContentCopyIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};

export default SummaryTabHeader; 